import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React, { Component } from 'react';
import createReactContext from 'create-react-context';
import hoistStatics from 'hoist-non-react-statics';
var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false,
  omitBoundRerender: true
};
var i18nInstance;
export function setDefaults(options) {
  defaultOptions = _objectSpread({}, defaultOptions, options);
}
export function getDefaults() {
  return defaultOptions;
}
export function setI18n(instance) {
  i18nInstance = instance;
}
export function getI18n() {
  return i18nInstance;
}
export var reactI18nextModule = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
export var I18nContext = createReactContext(); // hoc for context

export function withContext() {
  return function Wrapper(WrappedComponent) {
    var WithContext = /*#__PURE__*/
    function (_Component) {
      _inherits(WithContext, _Component);
      function WithContext() {
        _classCallCheck(this, WithContext);
        return _possibleConstructorReturn(this, _getPrototypeOf(WithContext).apply(this, arguments));
      }
      _createClass(WithContext, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
            innerRef = _this$props.innerRef,
            rest = _objectWithoutProperties(_this$props, ["innerRef"]);
          if (innerRef) rest.ref = innerRef;
          return React.createElement(I18nContext.Consumer, null, function (ctx) {
            return React.createElement(WrappedComponent, _objectSpread({}, ctx, rest));
          });
        }
      }]);
      return WithContext;
    }(Component);
    return WithContext;
  };
}
function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}
/* eslint-disable react/no-multi-comp */

export function withI18n() {
  return function Wrapper(WrappedComponent) {
    var WithMergedOptions = /*#__PURE__*/
    function (_Component2) {
      _inherits(WithMergedOptions, _Component2);
      function WithMergedOptions() {
        _classCallCheck(this, WithMergedOptions);
        return _possibleConstructorReturn(this, _getPrototypeOf(WithMergedOptions).apply(this, arguments));
      }
      _createClass(WithMergedOptions, [{
        key: "render",
        value: function render() {
          var _this = this;
          var _this$props2 = this.props,
            innerRef = _this$props2.innerRef,
            rest = _objectWithoutProperties(_this$props2, ["innerRef"]);
          if (innerRef) rest.ref = innerRef; // merged extra props

          var extraProps = {};
          var i18nOptions = this.props.i18nOptions || this.i18nOptions; // as default we add i18n, basic t function and i18nOptions from setI18n
          // those get overridden by values passed by I18nContext.Provider <- eg. set in I18nextProvider

          var i18n = this.props.i18n || getI18n();
          if (!i18nOptions) {
            var possibleI18nOptionsFromProps = Object.keys(defaultOptions).reduce(function (mem, k) {
              if (_this.props[k]) mem[k] = _this.props[k];
              return mem;
            }, {});
            i18nOptions = _objectSpread({}, getDefaults(), i18n && i18n.options && i18n.options.react, possibleI18nOptionsFromProps);
            this.i18nOptions = i18nOptions;
          }
          if (i18n) {
            extraProps.i18n = i18n;
            extraProps.t = i18n.t.bind(i18n);
            extraProps.lng = i18n.language;
            extraProps.i18nOptions = i18nOptions;
          }
          return React.createElement(WrappedComponent, _objectSpread({}, extraProps, rest));
        }
      }]);
      return WithMergedOptions;
    }(Component);
    var WithMergedOptionsWithContext = withContext()(WithMergedOptions);
    WithMergedOptionsWithContext.WrappedComponent = WrappedComponent;
    WithMergedOptionsWithContext.displayName = "WithMergedOptions(".concat(getDisplayName(WrappedComponent), ")");
    return hoistStatics(WithMergedOptionsWithContext, WrappedComponent);
  };
}